import type React from 'react';

import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import { Box, IconButton, useTheme } from '@mui/material';
import { useReactFlow } from '@xyflow/react';
import { useTranslate } from 'react-admin';

import type { Node } from '@xyflow/react';

interface NodeControlHeaderProps {
  node: Node | undefined;
  handleDrawerClose: () => void;
}

const NodeControlHeader = ({ node, handleDrawerClose }: NodeControlHeaderProps): React.ReactElement => {
  const theme = useTheme();
  const translate = useTranslate();
  const reactFlowInstance = useReactFlow();

  const handleNodeDelete = (): void => {
    if (node !== undefined && reactFlowInstance !== undefined) {
      void reactFlowInstance.deleteElements({ nodes: [node] });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
      }}
    >
      <Box display='flex' flexWrap='nowrap' alignItems='center' gap={theme.spacing(1)}>
        <IconButton onClick={handleDrawerClose}>
          <ChevronRightRoundedIcon />
        </IconButton>
        {node?.type !== undefined && (
          <h4>
            {translate('callflows.interface.controlsTitle', { node: translate(`callflows.nodes.${node.type}.name`) })}
          </h4>
        )}
      </Box>
      {node?.deletable !== true && (
        <Box>
          <IconButton
            onClick={() => {
              handleNodeDelete();
              handleDrawerClose();
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default NodeControlHeader;
